/**
 * Questionnaires API Service
 * Handles all questionnaire-related API calls
 */
import { api } from './api.js'

const BASE_URL = '/api/questionnaires'

export const questionnairesService = {
  /**
   * Get all questionnaires
   * @param {boolean} includeInactive - Include inactive questionnaires (for admin view)
   */
  list: (includeInactive = false) =>
    api.get(`${BASE_URL}${includeInactive ? '?includeInactive=true' : ''}`),

  /**
   * Get questionnaire by ID
   */
  get: (id) => api.get(`${BASE_URL}/${id}`),

  /**
   * Create questionnaire
   */
  create: (data) => api.post(BASE_URL, data),

  /**
   * Update questionnaire
   */
  update: (id, data) => api.patch(`${BASE_URL}/${id}`, data),

  /**
   * Delete questionnaire
   */
  delete: (id) => api.delete(`${BASE_URL}/${id}`),

  /**
   * Duplique un questionnaire avec ses questions.
   * @param {number} id - Questionnaire à copier
   * @param {{ code?: string, name?: string }} data - Laissés vides, le serveur propose
   */
  duplicate: (id, data = {}) => api.post(`${BASE_URL}/${id}/duplicate`, data),

  /**
   * Add question to questionnaire
   */
  addQuestion: (questionnaireId, questionData) =>
    api.post(`${BASE_URL}/${questionnaireId}/questions`, questionData),

  /**
   * Update question
   */
  updateQuestion: (questionnaireId, questionId, data) =>
    api.patch(`${BASE_URL}/${questionnaireId}/questions/${questionId}`, data),

  /** Glisse une question (et ses questions liées) dans un autre questionnaire. */
  deplacerQuestion: (questionnaireId, questionId, destination) =>
    api.post(`${BASE_URL}/${questionnaireId}/questions/${questionId}/deplacer`, destination),

  /** Copie une question sur place (ou une question commune depuis sa ligne d'insertion). */
  dupliquerQuestion: (questionnaireId, questionId, destination) =>
    api.post(`${BASE_URL}/${questionnaireId}/questions/${questionId}/dupliquer`, destination),

  /**
   * Coche ou décoche « Question commune » : la question devient un bloc
   * commun, ou en sort (chaque questionnaire qui l'insérait en garde sa copie).
   */
  basculerQuestionCommune: (questionnaireId, questionId, commune) =>
    api.post(`${BASE_URL}/${questionnaireId}/questions/${questionId}/commune`, { commune }),

  /**
   * Delete question
   */
  deleteQuestion: (questionnaireId, questionId) =>
    api.delete(`${BASE_URL}/${questionnaireId}/questions/${questionId}`),

  /**
   * Get questionnaires for a formation
   */
  getForFormation: (formationId) =>
    api.get(`${BASE_URL}/formation/${formationId}`),

  /**
   * Assign questionnaire to formation
   */
  assignToFormation: (formationId, questionnaireId) =>
    api.post(`${BASE_URL}/formation/${formationId}/assign`, { questionnaireId }),

  /**
   * Remove questionnaire from formation
   */
  removeFromFormation: (formationId, questionnaireId) =>
    api.delete(`${BASE_URL}/formation/${formationId}/unassign/${questionnaireId}`)
}
